module.exports = __webpack_public_path__ + "static/media/icon_sort_down.e9654be1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/icon_sort_down.png
// module id = 456
// module chunks = 0